// Shared Loyalty & Rewards data, importable from both the client page
// component and server route (JSON-LD generation).
export const loyaltyFaqs = [
  {
    question:
      "Can I customize the loyalty page to match my store's brand identity?",
    answer:
      "Yes. KeyStone is built for full customization, allowing you to tailor layouts, designs, and program rules to match your brand perfectly.",
  },
  {
    question: "Is coding knowledge required to set up the loyalty program?",
    answer:
      "No. You can launch your loyalty program fast, with the full platform and storefront customization controls available, no coding needed.",
  },
  {
    question: "What kinds of actions can customers be rewarded for?",
    answer:
      "You can reward customers for various actions, including purchases, signups, celebrating birthdays, and more.",
  },
  {
    question: "Does KeyStone include a referral program?",
    answer:
      "Yes. KeyStone allows happy customers to bring in new shoppers through shareable referral rewards, helping to grow your customer base.",
  },
  {
    question: "Can my customers use their rewards when shopping in-store?",
    answer:
      "Yes, the app is fully compatible with Shopify POS for in-store rewards, ensuring an omnichannel experience.",
  },
  {
    question: "What kinds of rewards can I offer?",
    answer:
      "You can offer discounts, free shipping, free products/gifts, and exclusive perks through VIP tiers to motivate long-term loyalty.",
  },
];

// Posts linked from /loyalty, ordered by commercial intent.
export const loyaltyGuides = [
  {
    slug: "best-shopify-loyalty-apps-2026-comparison",
    title: "Best Shopify loyalty apps in 2026, compared",
    description:
      "Smile.io, Rivo, BON, Joy, LoyaltyLion, Yotpo and Keystone on live App Store pricing, free plans and VIP tier costs.",
  },
  {
    slug: "smile-io-alternatives-2026",
    title: "Seven Smile.io alternatives for Shopify",
    description:
      "Real pricing for Keystone, Rivo, BON, Joy, LoyaltyLion, Yotpo and Appstle, including where VIP tiers start.",
  },
  {
    slug: "shopify-pos-loyalty-program-setup-guide",
    title: "Shopify POS loyalty: in-store rewards setup",
    description:
      "Five steps from installing the POS tile to earning parity, redemption and staff training.",
  },
  {
    slug: "referral-program-ideas-shopify-examples",
    title: "12 referral program ideas for Shopify, with the math",
    description:
      "Cash, points, tiered milestones and VIP multipliers, plus the fraud checks each one needs.",
  },
  {
    slug: "how-many-loyalty-points-per-dollar-shopify",
    title: "How many points per dollar should you give?",
    description:
      "Set points per dollar, point value and reward thresholds so the return rate fits your margin.",
  },
  {
    slug: "when-should-loyalty-points-expire",
    title: "When should loyalty points expire?",
    description:
      "Expire on inactivity rather than age, outlast your repurchase cycle, and always warn first.",
  },
];
